import React from 'react'
import Footer from 'components/Footer'
import DynamicHeader from 'components/DynamicHeader'
import { Box, IconButton } from '@mui/material'
import { PartnerPageData, SiteContent } from 'types/types'
import { BASE_API_URL } from '@/configs'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import axios from 'axios'
import { UserApi } from 'api/api'
import Page from 'components/Page'
import { useRouter } from 'next/router'

function Privacy({ siteContent, page }: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter()

  const handleGoBack = () => {
    router.push({
      pathname: `/${page.company_domain}/games/${page.game_id}`,
      query: { ...router.query, redirectBackToLanding: 'false' },
    })
  }

  return (
    <Page
      display="flex"
      justifyContent="space-between"
      flexDirection="column"
      height="100vh"
      pageName="privacy-pol"
      title={page.site_title}
      image={page.metadata_image}
      description={page.metadata_content}
      favicon={page.favicon}
    >
      <div>
        <DynamicHeader pageTheme={{ ...page, is_user_joined: false }} shouldShowBox={false} />
        <Box display="flex" justifyContent="flex-start" ml={4} mb={2}>
          <IconButton onClick={handleGoBack} sx={{ width: 14, height: 14, mt: 2 }}>
            <ArrowBackIosIcon sx={{ width: 14, height: 14 }} />
          </IconButton>
        </Box>
        <Box
          dangerouslySetInnerHTML={{ __html: siteContent?.content ?? '' }}
          sx={{
            backgroundColor: '#DDDDDD70',
            padding: '2rem',
            margin: '2rem',
            borderRadius: '0.5rem',
            '&>*': {
              marginBottom: '1rem',
            },
            '@media (min-width:600px)': {
              padding: '4rem',
            },
          }}
        />
      </div>
      <Footer page={page} />
    </Page>
  )
}

export default Privacy

export async function getStaticPaths() {
  const response = await axios.get(`${BASE_API_URL}/b2b/partner-pages`)
  const paths = response.data.map(
    ({ company_domain }: { company_domain: string }) => `/${company_domain}/privacypol`,
  )
  return { paths, fallback: 'blocking' }
}

export async function getStaticProps({ params }: GetStaticPropsContext<{ slug: string }>) {
  const [res, content] = await Promise.all([
    axios.get<PartnerPageData>(`${BASE_API_URL}/b2b/partner-pages/${params?.slug}`),
    UserApi.getSiteContent((params?.slug as string) ?? 'vpar', 'PRIVACY_POLICY').catch(() => {
      return { content: '' } as SiteContent
    }),
  ])

  return {
    props: {
      page: res.data,
      siteContent: content,
    },
    revalidate: 60,
  }
}
